export default __webpack_public_path__ + "static/media/shape_1.6285ce54.png";